import VueI18n from "vue-i18n";

export default function() {
  return new VueI18n({
    locale: "de",
    messages: {
      en: {
        message: {
          loading: "Loading…",
          noData: "no data",
          noEvents:
            "No matching events could be found. Please change your filter settings.",
          map: "Map",
          showMap: "Show map",
          hideMap: "Hide map",
          highlight: "Top-Event",
          at: "{date} at {time}h",
          filterEvents: "Filter events",
          filterEventsShort: "Filter",
          filterHeader: "Filter",
          searchResults:
            "No search results | One search result | {count} search results",
          countFavorites: "{count} favorites",
          category: "Category",
          sortings: "Sorting",
          sort_moment: "Currentness",
          sort_title: "Title",
          asc: "ascending",
          desc: "descending",
          searchTerm: "Search",
          period: "Period",
          today: "Today",
          tomorrow: "Tomorrow",
          weekend: "Weekend",
          allDates: "Reset",
          dateFormat: "{1}/{0}/{2}",
          cue: "Cue",
          mapMarkerHeader:
            "No events at this location | 1 event at this location | {count} events at this location",
          mapMarkerShowForLocation: "Show all events here",
          location: "Location",
          resetFilter: "Reset search",
          findButton: "No events found | Find 1 event | Find {count} events",
          showDistinctEvents: "Display first event of series only"
        }
      },
      de: {
        message: {
          loading: "Lade…",
          noData: "Keine Daten",
          noEvents:
            "Es wurden keine passenden Veranstaltungen gefunden. Bitte ändern Sie Ihre Filter.",
          map: "Karte",
          showMap: "Zeige Karte",
          hideMap: "Schließe Karte",
          highlight: "Top-Veranstaltung",
          cancelled: "Abgesagt!",
          at: "{date} um {time} Uhr",
          filterEvents: "Events filtern",
          filterEventsShort: "Filtern",
          filterHeader: "Filter",
          searchResults:
            "Keine Suchergebnisse | Ein Suchergebnis | {count} Suchergebnisse",
          countFavorites: "{count} gemerkt",
          category: "Kategorie",
          sortings: "Sortierung",
          sort_moment: "Datum",
          sort_title: "Titel",
          asc: "aufsteigend",
          desc: "absteigend",
          searchTerm: "Suche",
          period: "Zeitraum wählen",
          today: "Heute",
          tomorrow: "Morgen",
          weekend: "Wochenende",
          allDates: "Alle Termine",
          dateFormat: "{0}.{1}.{2}",
          cue: "Stichwort",
          mapMarkerHeader:
            "Keine Veranstaltungen zu diesem Standort | 1 Veranstaltung zu diesem Standort | {count} Veranstaltungen zu diesem Standort",
          mapMarkerShowForLocation: "Alle Veranstaltungen zum Ort zeigen",
          location: "Ort",
          resetFilter: "Angaben löschen",
          findButton:
            "Keine Veranstaltungen gefunden | 1 Veranstaltung finden | {count} Veranstaltungen finden",
          showDistinctEvents: "Nur ersten Termin je Serie anzeigen"
        }
      }
    }
  });
}
